import Modal from 'react-modal';
import { useEffect, useState, useRef } from 'react';
import './moviment.css';
import Header from '../../../components/Header';
import Division from '../../../components/Division';
import Lateral from '../../../components/Lateral';
import { toast } from 'react-toastify';
import api from '../../../config.js';
import { getPermission, releaseAddress, setMaskDecimal, getLabels, showMessageError } from '../../../classes/functions';
import ReactTooltip from "react-tooltip";
import Title from '../../../components/Title';
import { FaArrowLeft, FaArrowRight, FaCog, FaSearch } from 'react-icons/fa';
import ProductInput from '../../../components/Inputs/ProductInput';
import { RiArrowUpDownLine } from 'react-icons/ri';

const customStylesModal = {
    content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        width: '700px',
        maxHeight: '80%',
        bottom: 'auto',
        marginRight: '-50%',
        transform: 'translate(-50%, -50%)',
    },
};

export default function ManualMoviment() {
    const [modalOpen, setModalOpen] = useState(false);
    const [tipo, setTipo] = useState('');
    const [listTiposMovimentacao, setListTiposMovimentacao] = useState([]);
    const [listAddress, setListAddress] = useState([]);
    const [label_warehouse_origin, setLabelWarehouseOrigin] = useState('');
    const [label_warehouse_destination, setLabelWarehouseDestination] = useState('');
    const [disableDestino, setDisableDestino] = useState(false);
    const [listSearchWarehousesOrigin, setListSearchWarehousesOrigin] = useState([]);
    const [listSearchWarehousesDestination, setListSearchWarehousesDestination] = useState([]);

    const [label_address_origin, setLabelAddressOrigin] = useState('');
    const [label_address_destination, setLabelAddressDestination] = useState('');
    const [listSearchAddressOrigin, setListSearchAddressOrigin] = useState([]);
    const [listSearchAddressDestination, setListSearchAddressDestination] = useState([]);
    const [codeProduct, setCodeProduct] = useState('');

    const [listFeatures, setListFeatures] = useState([]);
    const [listWarehouses, setListWarehouses] = useState([]);
    const [conferenceFeatures, setConferenceFeatures] = useState([]);
    const [conferenceFeaturesDestination, setConferenceFeaturesDestination] = useState([]);

    const [qtdeProductFeature, setQtdeProductFeature] = useState([]);

    const [etiquetaPalete, setEtiquetaPalete] = useState('');
    const [warehouseOrigin, setWarehouseOrigin] = useState('');
    const [warehouseDestination, setWarehouseDestination] = useState('');
    const [addressOrigin, setAddressOrigin] = useState('');
    const [addressDestination, setAddressDestination] = useState('');
    const [filters, setFilters] = useState({
        dataDe: '',
        dataAte: '',
        produto: '',
        feature: ''
    });
    const [labels, setLabels] = useState([]);
    const [indexs, setIndexs] = useState([]);
    const [itemForSorting, setItemForSorting] = useState('ID');
    const [sortingType, setSortingType] = useState('DESC');
    const [qtdePage, setQtdePage] = useState(50);
    const [limitPage, setLimitPage] = useState(1);
    const [search, setSearch] = useState('');
    const [page, setPage] = useState(1);

    const [product, setProduct] = useState('');
    const [amount, setAmount] = useState('');

    const [enableConfirm, setEnableConfirm] = useState('');
    const [carrying, setCarrying] = useState(true);

    const [listProducts, setListProducts] = useState([]);
    const [label_product, setLabelProduct] = useState([]);
    const [listSearchProduct, setListSearchProduct] = useState([]);
    const [products, setProducts] = useState([]);
    const [manualsMovements, setManualsMovements] = useState([]);
    const table = useRef();

    function openExitConference() {
        setModalOpen(false);
    }

    function handleInput(event, setState) {
        const { value, name } = event.target;

        setState((prevState) => ({
            ...prevState,
            [name]: value
        }));
    }

    function setAutoEtiquetaPalete(e) {
        setEtiquetaPalete(e.target.value.toUpperCase());
        if (e.target.value.length === 17) {
            api.get("/api/entry_documents/confereTag?type=P&tag=" + e.target.value.toUpperCase())
                .then((response) => {
                    if (response.data.gerada === false) {
                        toast.error('Etiqueta não existe.');
                    }
                }).catch((error) => {
                    showMessageError(error.response.data);
                });
        }
    }

    function setChangeTipo(e) {
        setTipo(e.target.value);
        inicializeMoviment();
    }

    function closeModal() {
        inicializeMoviment();
        setTipo('');
        setModalOpen(false);
    }

    useEffect(() => {
        getData();
    }, []);

    useEffect(() => {
        let retorno = false;
        if (!tipo) {
            retorno = false;
        } else if ((tipo === '001') && ((etiquetaPalete === ''))) {
            // toast.error('Todos os campos com * devem ser preenchidos.');
        } else {
            retorno = true;
        }

        setEnableConfirm(!retorno);
    }, [tipo, etiquetaPalete]);

    function validate() {
        if (tipo == '001') {
            let destinationWarehouseExists = [];
            let destinationAddressExists = [];

            listWarehouses.map((warehouse) => {
                if (warehouse.codigo_armazem === label_warehouse_destination?.split('-')[0]?.trim()) {
                    destinationWarehouseExists.push(warehouse);
                }
            });

            listAddress.map((address) => {
                if (address.descricao === label_address_destination) {
                    destinationAddressExists.push(address);
                }
            });

            if (destinationAddressExists.length === 0) {
                toast.error('Por favor, insira um endereço de destino válido.');

                return false;
            }

            if (destinationWarehouseExists.length === 0) {
                toast.error('Por favor, insira um armazém de destino válido.');

                return false;
            }
        } else if (tipo == '002') {
            let originWarehouseExists = [];
            let destinationWarehouseExists = [];
            let originAddressExists = [];
            let destinationAddressExists = [];

            listWarehouses.map((warehouse) => {
                if (warehouse.codigo_armazem === label_warehouse_origin?.split('-')[0]?.trim()) {
                    originWarehouseExists.push(warehouse);
                }

                if (warehouse.codigo_armazem === label_warehouse_destination?.split('-')[0]?.trim()) {
                    destinationWarehouseExists.push(warehouse);
                }
            });

            listAddress.map((address) => {
                if (address.descricao === label_address_origin) {
                    originAddressExists.push(address);
                }

                if (address.descricao === label_address_destination) {
                    destinationAddressExists.push(address);
                }
            });

            if (originAddressExists.length === 0) {
                toast.error('Por favor, insira um endereço de origem válido.');

                return false;
            }

            if (destinationAddressExists.length === 0) {
                toast.error('Por favor, insira um endereço de destino válido.');

                return false;
            }

            if (originWarehouseExists.length === 0) {
                toast.error('Por favor, insira um armazém de origem válido.');

                return false;
            }

            if (destinationWarehouseExists.length === 0) {
                toast.error('Por favor, insira um armazém de destino válido.');

                return false;
            }

            if (label_warehouse_origin === label_warehouse_destination && label_address_origin === label_address_destination && conferenceFeatures[0]?.valor === conferenceFeaturesDestination[0]?.valor) {
                toast.error('Origem e destino de armazém ou endereço não podem ser iguais.');
                setCarrying(false);
                return false;
            }
        } else if (tipo == '003') {
            let originWarehouseExists = [];
            let destinationWarehouseExists = [];
            let originAddressExists = [];
            let destinationAddressExists = [];
            let productsExists = [];

            listProducts.map((product) => {
                if (product.codigo_produto && product.descricao === label_product) {
                    productsExists.push(product);
                }
            });

            listWarehouses.map((warehouse) => {
                if (warehouse.codigo_armazem === label_warehouse_origin?.split('-')[0]?.trim()) {
                    originWarehouseExists.push(warehouse);
                }

                if (warehouse.codigo_armazem === label_warehouse_destination?.split('-')[0]?.trim()) {
                    destinationWarehouseExists.push(warehouse);
                }
            });

            listAddress.map((address) => {
                if (address.descricao === label_address_origin) {
                    originAddressExists.push(address);
                }

                if (address.descricao === label_address_destination) {
                    destinationAddressExists.push(address);
                }
            });

            if (originAddressExists.length === 0) {
                toast.error('Por favor, insira um endereço de origem válido.');

                return false;
            }

            if (destinationAddressExists.length === 0) {
                toast.error('Por favor, insira um endereço de destino válido.');

                return false;
            }

            if (originWarehouseExists.length === 0) {
                toast.error('Por favor, insira um armazém de origem válido.');

                return false;
            }

            if (destinationWarehouseExists.length === 0) {
                toast.error('Por favor, insira um armazém de destino válido.');

                return false;
            }

            if (productsExists.length === 0) {
                toast.error('Por favor, insira um produto válido.');

                return false;
            }

            if (parseFloat(qtdeProductFeature) < parseFloat(amount)) {
                toast.error('Não há saldo suficiente para esse produto.');
                setCarrying(false);
                return false;
            }

            if (label_warehouse_origin === label_warehouse_destination && label_address_origin === label_address_destination && conferenceFeatures[0]?.valor === conferenceFeaturesDestination[0]?.valor) {
                toast.error('Origem e destino de armazém ou endereço não podem ser iguais.');
                setCarrying(false);
                return false;
            }
        } 
        
        return true;
    }

    function save() {
        if (validate()) {
            setCarrying(true);

            const data = {
                type: tipo,
                list: [{
                    etiqueta_palete: etiquetaPalete,
                    id_armazem_origem: warehouseOrigin,
                    features: conferenceFeatures,
                    features_destination: conferenceFeaturesDestination,
                    id_endereco_origem: addressOrigin,
                    id_produto: codeProduct,
                    quantidade: amount,
                    id_armazem_destino: warehouseDestination,
                    id_endereco_destino: addressDestination,
                }]
            }

            api.post("/api/setManualMovement", data).then((response) => {
                if (response.data.success === false) {
                    response.data.message.forEach(element => {
                        toast.error(element);
                    });
                    setCarrying(false);
                    releaseAddress();
                } else {
                    toast.success('Registro atualizado com sucesso.');
                    inicializeMoviment();
                    setTipo('');
                    setCarrying(false);
                }
            }).catch((error) => {
                setCarrying(false);
                showMessageError(error.response.data);
            });
        }
    }

    function getData() {
        api.get("/api/manual_movement/getDataPage")
            .then((response) => {
                setListTiposMovimentacao(response.data.tipos);
                setListAddress(response.data.enderecos);
                setListProducts(response.data.products);
                setListWarehouses(response.data.warehouses);
                setListFeatures(response.data.features);
                setCarrying(false);
            }).catch((error) => {
                showMessageError(error.response.data);
                setCarrying(false);
            });
    }

    function inicializeMoviment() {
        setEtiquetaPalete('');
        setWarehouseOrigin('');
        setAddressOrigin('');
        setProduct('');
        setAmount('');
        setWarehouseDestination('');
        setAddressDestination('');
        setLabelProduct('');
        setLabelWarehouseOrigin('');
        setLabelAddressOrigin('');
        setLabelWarehouseDestination('');
        setLabelAddressDestination('');
        setConferenceFeatures([]);
        setConferenceFeaturesDestination([]);
    }

    function searchWarehouseOrigin(term) {
        setListSearchWarehousesOrigin(listWarehouses.filter((element) =>
            element.codigo_armazem.toUpperCase().includes(term.toUpperCase()) || element.descricao.toUpperCase().includes(term.toUpperCase()))
        )
    }

    function searchWarehouseDestination(term) {
        setListSearchWarehousesDestination(listWarehouses.filter((element) =>
            element.codigo_armazem.toUpperCase().includes(term.toUpperCase()) || element.descricao.toUpperCase().includes(term.toUpperCase())
        ));
    }

    function selectWarehouseOrigin(item) {
        setLabelWarehouseOrigin(item.codigo_armazem + ' - ' + item.descricao);
        setWarehouseOrigin(item.id);
        setListSearchWarehousesOrigin([]);
    }

    function selectWarehouseDestination(item) {
        setLabelWarehouseDestination(item.codigo_armazem + ' - ' + item.descricao);
        setWarehouseDestination(item.id);
        setListSearchWarehousesDestination([]);
    }

    function searchAddressOrigin(term) {
        setListSearchAddressOrigin(listAddress.filter((element) =>
            element.endereco.toUpperCase().includes(term.toUpperCase())
        ));
    }

    function searchAddressDestination(term) {
        setListSearchAddressDestination(listAddress.filter((element) =>
            (element.endereco.toUpperCase().includes(term.toUpperCase()))
        ));
    }

    function setList(index, value) {
        let aux = [];
        conferenceFeatures.forEach((element, inx) => {
            if (inx === index) {
                element.valor = value.toUpperCase();

                if (value.slice(0, 1).toUpperCase() !== 'K') {
                    setDisableDestino(true);
                } else {
                    setDisableDestino(false);
                }
            }
            aux.push(element)
        });

        setConferenceFeatures(() => aux);
        setListDestination(index, value);
    }

    function setListDestination(index, value) {
        let aux = [];
        conferenceFeaturesDestination.forEach((element, inx) => {
            if (inx === index) {
                element.valor = value.toUpperCase();
            }
            aux.push(element)
        });

        setConferenceFeaturesDestination(() => aux);
    }

    function selectAddressOrigin(item) {
        setLabelAddressOrigin(item.descricao);
        setAddressOrigin(item.id);
        setListSearchAddressOrigin([]);
    }

    function selectAddressDestination(item) {
        setLabelAddressDestination(item.descricao);
        setAddressDestination(item.id);
        setListSearchAddressDestination([]);
    }

    function searchProduct(term) {
        setListSearchProduct(listProducts.filter((element) =>
            (element.descricao.toUpperCase().includes(term.toUpperCase()) || element.codigo_produto.toUpperCase().includes(term.toUpperCase()))
        ));
    }

    function validateFeature(feature, value) {
        api.get("/api/products/getValidateFeature?feature=" + feature + "&value=" + value)
            .then(() => {
                return value;
            }).catch((error) => {
                showMessageError(error.response.data);
                return '';
            });
    }

    function getBalance(product = codeProduct) {
        let data = {
            data: {
                product: product,
                features: conferenceFeatures,
                warehouse: warehouseOrigin,
                address: addressOrigin
            }
        }
        api.post("/api/products/getBalanceByAddressFeatures", data)
            .then((response) => {
                setQtdeProductFeature(response.data.product);
            }).catch((error) => {
                showMessageError(error.response.data);
                setCarrying(false);
            });
    }

    function selectProduct(item) {
        setLabelProduct(item.descricao);
        setCodeProduct((prevState => (item.id)));
        setFilters((prevState => ({ ...prevState, produto: `${item.codigo_produto} - ${item.descricao}` })));
        setListSearchProduct([]);
        setProducts([]);

        api.get("/api/getFeaturesByProductMovement?id=" + item.id)
            .then((response) => {
                if (response.data.features.length > 0) {
                    setConferenceFeatures(response.data.features);
                    setConferenceFeaturesDestination(response.data.features_destination);
                } else {
                    getBalance(item.id);
                }
            }).catch((error) => {
                showMessageError(error.response.data);
                setCarrying(false);
            });
    }

    function getManualsMovements() {
        api
            .get(`/api/manual_movement?page=${page}&qtdePage=${qtdePage}&search=${search}&ID_PRODUTO=${filters.produto.split('-')[0].trim()}&dataDe=${filters.dataDe}&dataAte=${filters.dataAte}&VALOR=${filters.feature}&property=${itemForSorting === 'QUANTIDADE' ? 'balances.QUANTIDADE' : itemForSorting}&sortingType=${sortingType}`)
            .then((response) => {
                var items = getLabels(response.data.data);
                setLabels(Object.values(items[0]));
                setIndexs(Object.values(items[1]));
                setCarrying(false);
                setLimitPage(parseInt(response.data.total / qtdePage) + 1);
                setManualsMovements(response.data.data);
            })
            .catch((error) => {
                console.log(error);
            });
    }
    
    useEffect(() => {
        getManualsMovements();
    }, [, itemForSorting, sortingType]);

    useEffect(() => {
        setPage(1);
    }, [qtdePage]);

    return (
        <div>
            <Header />
            <Division />
            <Lateral />
            <ReactTooltip />
            {carrying && <div className="content">
                <div className="divCarrying">
                    <span>Carregando..</span>
                    <FaCog icon="spinner" className="spinner" />
                </div>
            </div>}
            {!carrying && <div className="content">
                {getPermission('OPERACOES - MOVIMENTACAO MANUAL - CADASTRO') && <Title name="Movimentação Manual">
                    <button className="buttonInsert" onClick={() => {
                        setModalOpen(true)
                    }}>
                        Cadastrar
                    </button>
                    <select className='selectQtdeItens' value={qtdePage} onChange={(e) => { setQtdePage(e.target.value) }}>
                        <option value="50">Itens por página</option>
                        <option value="10">10</option>
                        <option value="20">20</option>
                        <option value="30">30</option>
                        <option value="40">40</option>
                        <option value="50">50</option>
                    </select>
                    <input className="inputSearch" onChange={(e) => setSearch(e.target.value)} type="text" placeholder="Pesquisar" />
                    <FaSearch className="iconSearch" style={{ color: '#001675' }} size={16} />
                </Title>}
                <div className="containerGroupData">
                    <h2>Filtros</h2>
                    <hr></hr>
                    <div className="divGroup">
                        <div className="formDiv">
                            <label>Data De</label><br />
                            <input type='date' name='dataDe' style={{ height: '37.5px' }} value={filters.dataDe} onChange={(e) => handleInput(e, setFilters)} />
                        </div>

                        <div className="formDiv">
                            <label>Data Até</label><br />
                            <input type='date' name='dataAte' style={{ height: '37.5px' }} value={filters.dataAte} onChange={(e) => handleInput(e, setFilters)} />
                        </div>

                        <ProductInput filters={filters} setFilters={setFilters} products={products} setProducts={setProducts} selectProduct={selectProduct} />

                        {listFeatures.length > 0 && <div className="formDiv">
                            <label>Característica</label><br />
                            <input type='text' placeholder='Característica' style={{ height: '37.5px' }} value={filters.feature} onChange={(e) => setFilters((prevState) => ({
                                ...prevState,
                                feature: e.target.value
                            }))} />
                        </div>}
                    </div>
                    <div className="divGroup">
                        <div className="formDiv">
                            <div>
                                <button className="buttonInsertMargin" onClick={getManualsMovements}>
                                    Pesquisar
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
                <div style={{overflowX: "scroll", maxWidth: "100%"}}>
                    <table ref={table}>
                        <thead>
                            <tr>
                                {labels?.map((label, index) => {
                                    return (
                                        <th scope="col" key={index} style={{width: "150px"}}>
                                            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
                                                <p>{label}</p>
                                                <button style={{ backgroundColor: 'inherit', fontSize: '1rem', marginLeft: '0.5rem', marginTop: '0.25rem', padding: '0', width: 'inherit', height: 'inherit' }}>
                                                    <RiArrowUpDownLine onClick={() => { sortingType === 'ASC' ? setSortingType('DESC') : setSortingType('ASC'); setItemForSorting(indexs[index]) }} />
                                                </button>
                                            </div>
                                        </th>
                                    )
                                })}
                            </tr>
                        </thead>
                        <tbody>
                            {manualsMovements.map((manualMovement, index) => {
                                return (
                                    <tr key={index}>
                                        {indexs.map((label, i) => {
                                            return (
                                                <td scope="col">{manualMovement[label]}</td>
                                            )
                                        })}
                                    </tr>
                                )
                            })}
                        </tbody>
                    </table>
                    <br />
                    <div className="divGroupPagination">
                        <button data-tip="Primeira página" onClick={() => setPage(1)} type="button" className="buttonFirstPage"><FaArrowLeft color="#001675" size={17} /><FaArrowLeft color="#001675" size={17} /></button>
                        <button data-tip="Página anterior" onClick={() => setPage(page > 1 ? page - 1 : 1)} type="button" className="buttonPreviewPage"><FaArrowLeft color="#001675" size={17} /></button>
                        <div className="divLabelPagination">
                            <center><label className="labelPage">Exibindo página {page} de {limitPage}</label></center>
                        </div>
                        <button data-tip="Próxima página" onClick={() => setPage((page + 1) < limitPage ? page + 1 : limitPage)} type="button" className="buttonNextPage"><FaArrowRight color="#001675" size={17} /></button>
                        <button data-tip="Última página" onClick={() => setPage(limitPage)} type="button" className="buttonLastPage"><FaArrowRight color="#001675" size={17} /><FaArrowRight color="#001675" size={17} /></button>
                    </div>
                </div>

                <Modal
                    isOpen={modalOpen}
                    onRequestClose={closeModal}
                    style={customStylesModal}
                    contentLabel="Movimentação Manual"
                    ariaHideApp={false}
                    keepMounted
                >
                    <h2>Movimentação Manual</h2>
                    <div className="body-modal">
                        <div>
                            <div className="divGroup">
                                <div className="formDiv">
                                    <label>Tipo</label>&nbsp;<label className="required">*</label><br />
                                    <select value={tipo} onChange={setChangeTipo}>
                                        <option value="">Selecione</option>
                                        {listTiposMovimentacao.map((item, index) => (
                                            <option key={index} value={item.chave}>{item.descricao}</option>
                                        ))}
                                    </select>
                                </div>
                            </div>
                        </div>
                        {tipo === '003' && <div>
                            <div className="divGroup">
                                <div className="formDiv">
                                    <label>Armazém Origem</label>&nbsp;<label className="required">*</label><br />
                                    <input type="text" placeholder="Armazém Origem" value={label_warehouse_origin}
                                        onChange={(e) => {
                                            setLabelWarehouseOrigin(e.target.value);
                                            searchWarehouseOrigin(e.target.value);
                                        }} maxLength="60" />
                                    <ul className="dropdown-menu" id="originWarehouseDatalist">
                                        {listSearchWarehousesOrigin.map((item, index) => {
                                            return (
                                                <li key={index} onClick={() => selectWarehouseOrigin(item)}>
                                                    <a>{item.descricao?.split('-')[1]?.trim() === undefined && `${item.codigo_armazem} - `}{item.descricao}</a>
                                                </li>
                                            )
                                        })}
                                    </ul>
                                </div>
                            </div>
                            <div className="divGroup">
                                <div className="formDiv">
                                    <label>Endereço Origem</label>&nbsp;<label className="required">*</label><br />
                                    <input type="text" placeholder="Endereço Origem" value={label_address_origin}
                                        onChange={(e) => {
                                            setLabelAddressOrigin(e.target.value);
                                            searchAddressOrigin(e.target.value);
                                        }} maxLength="60" />
                                    <ul className="dropdown-menu" id="originAddressDatalist">
                                        {listSearchAddressOrigin.map((item, index) => (
                                            <li key={index} onClick={() => selectAddressOrigin(item)}>
                                                <a>{item.endereco}</a>
                                            </li>
                                        ))}
                                    </ul>
                                </div>
                            </div>
                            <div className="divGroup">
                                <div className="formDiv">
                                    <label>Produto</label>&nbsp;<label className="required">*</label><br />
                                    <input type="text" placeholder="Produto" value={label_product} onChange={(e) => {
                                        setLabelProduct(e.target.value);
                                        searchProduct(e.target.value);
                                    }} maxLength="60" />
                                    <ul className="dropdown-menu" id="originAddressDatalist">
                                        {listSearchProduct.map((item, index) => {
                                            return (
                                                <li key={index} onClick={() => selectProduct(item)}>
                                                    <a>{item.codigo_produto} - {item.descricao}</a>
                                                </li>
                                            )
                                        })}
                                    </ul>
                                </div>
                            </div>
                            <div className="divGroup">
                                {conferenceFeatures.length > 0 && conferenceFeatures.map((item, index) => (
                                    <div className="formDiv">
                                        <label>{item.descricao} Origem</label><br />
                                        <input type="text" placeholder={item.descricao}
                                            value={conferenceFeatures[index].valor}
                                            onChange={(e) => setList(index, e.target.value)} onBlur={() => {
                                                getBalance();
                                                validateFeature(item.chave, item.valor);
                                            }} maxLength="30" />
                                    </div>
                                ))}
                            </div>
                            {qtdeProductFeature !== '' &&
                                <div><label>Saldo disponível: {qtdeProductFeature}</label></div>}
                            <div className="divGroup">
                                <div className="formDiv">
                                    <label>Quantidade</label>&nbsp;<label className="required">*</label><br />
                                    <input type="text" placeholder="Quantidade" value={amount}
                                        onChange={(e) => setAmount(setMaskDecimal(e.target.value))} maxLength="60" />
                                </div>
                            </div>
                            <div className="divGroup">
                                <div className="formDiv">
                                    <label>Armazém Destino</label>&nbsp;<label className="required">*</label><br />
                                    <input type="text" placeholder="Armazém Destino" value={label_warehouse_destination}
                                        onChange={(e) => {
                                            setLabelWarehouseDestination(e.target.value);
                                            searchWarehouseDestination(e.target.value);
                                        }} maxLength="60" />
                                    <ul className="dropdown-menu" id="destinationWarehouseDatalist">
                                        {listSearchWarehousesDestination.map((item, index) => (
                                            <li key={index} onClick={() => selectWarehouseDestination(item)}>
                                                <a>{item.codigo_armazem} - {item.descricao}</a>
                                            </li>
                                        ))}
                                    </ul>
                                </div>
                            </div>
                            <div className="divGroup">
                                <div className="formDiv">
                                    <label>Endereço Destino</label>&nbsp;<label className="required">*</label><br />
                                    <input type="text" placeholder="Endereço Destino" value={label_address_destination}
                                        onChange={(e) => {
                                            setLabelAddressDestination(e.target.value);
                                            searchAddressDestination(e.target.value);
                                        }} maxLength="60" />
                                    <ul className="dropdown-menu" id="destinationAddressDatalist">
                                        {listSearchAddressDestination.map((item, index) => (
                                            <li key={index} onClick={() => selectAddressDestination(item)}>
                                                <a>{item.endereco}</a>
                                            </li>
                                        ))}
                                    </ul>
                                </div>
                            </div>
                            {conferenceFeaturesDestination.length > 0 && conferenceFeaturesDestination.map((item_destination, index) => (
                                <div className="formDiv">
                                    <label>{item_destination.descricao} Destino</label><br />
                                    <input type="text" placeholder={item_destination.descricao}
                                        value={conferenceFeaturesDestination[index].valor}
                                        onChange={(e) => setListDestination(index, e.target.value)} onBlur={() => {
                                            validateFeature(item_destination.chave, item_destination.valor);
                                        }} disabled={disableDestino} maxLength="30" />
                                </div>
                            ))}
                        </div>}
                        {tipo === '001' && <div>
                            <div className="divGroup">
                                <div className="formDiv">
                                    <label>Etiqueta Palete</label>&nbsp;<label className="required">*</label><br />
                                    <input type="text" placeholder="Etiqueta Palete" value={etiquetaPalete}
                                        onChange={setAutoEtiquetaPalete} maxLength="30" />
                                </div>
                            </div>
                            <div className="divGroup">
                                <div className="formDiv">
                                    <label>Armazém Destino</label>&nbsp;<label className="required">*</label><br />
                                    <input type="text" placeholder="Armazém Destino" value={label_warehouse_destination}
                                        onChange={(e) => {
                                            setLabelWarehouseDestination(e.target.value);
                                            searchWarehouseDestination(e.target.value);
                                        }} maxLength="60" />
                                    <ul className="dropdown-menu" id="destinationWarehouseDatalist">
                                        {listSearchWarehousesDestination.map((item, index) => (
                                            <li key={index} onClick={() => selectWarehouseDestination(item)}>
                                                <a>{item.codigo_armazem} - {item.descricao}</a>
                                            </li>
                                        ))}
                                    </ul>
                                </div>
                            </div>
                            <div className="divGroup">
                                <div className="formDiv">
                                    <label>Endereço Destino</label>&nbsp;<label className="required">*</label><br />
                                    <input type="text" placeholder="Endereço Destino" value={label_address_destination}
                                        onChange={(e) => {
                                            setLabelAddressDestination(e.target.value);
                                            searchAddressDestination(e.target.value);
                                        }} maxLength="60" />
                                    <ul className="dropdown-menu" id="destinationAddressDatalist">
                                        {listSearchAddressDestination.map((item, index) => (
                                            <li key={index} onClick={() => selectAddressDestination(item)}>
                                                <a>{item.endereco}</a>
                                            </li>
                                        ))}
                                    </ul>
                                </div>
                            </div>
                        </div>}
                        {tipo === '002' && <div>
                            <div className="divGroup">
                                <div className="formDiv">
                                    <label>Armazém Origem</label>&nbsp;<label className="required">*</label><br />
                                    <input type="text" placeholder="Armazém Origem" value={label_warehouse_origin}
                                        onChange={(e) => {
                                            setLabelWarehouseOrigin(e.target.value);
                                            searchWarehouseOrigin(e.target.value);
                                        }} maxLength="60" />
                                    <ul className="dropdown-menu" id="originWarehouseDatalist">
                                        {listSearchWarehousesOrigin.map((item, index) => {
                                            return (
                                                <li key={index} onClick={() => selectWarehouseOrigin(item)}>
                                                    <a>{item.descricao?.split('-')[1]?.trim() === undefined && `${item.codigo_armazem} - `}{item.descricao}</a>
                                                </li>
                                            )
                                        })}
                                    </ul>
                                </div>
                            </div>
                            <div className="divGroup">
                                <div className="formDiv">
                                    <label>Endereço Origem</label>&nbsp;<label className="required">*</label><br />
                                    <input type="text" placeholder="Endereço Origem" value={label_address_origin}
                                        onChange={(e) => {
                                            setLabelAddressOrigin(e.target.value);
                                            searchAddressOrigin(e.target.value);
                                        }} maxLength="60" />
                                    <ul className="dropdown-menu" id="originAddressDatalist">
                                        {listSearchAddressOrigin.map((item, index) => (
                                            <li key={index} onClick={() => selectAddressOrigin(item)}>
                                                <a>{item.endereco}</a>
                                            </li>
                                        ))}
                                    </ul>
                                </div>
                            </div>
                            <div className="divGroup">
                                <div className="formDiv">
                                    <label>Armazém Destino</label>&nbsp;<label className="required">*</label><br />
                                    <input type="text" placeholder="Armazém Destino" value={label_warehouse_destination}
                                        onChange={(e) => {
                                            setLabelWarehouseDestination(e.target.value);
                                            searchWarehouseDestination(e.target.value);
                                        }} maxLength="60" />
                                    <ul className="dropdown-menu" id="destinationWarehouseDatalist">
                                        {listSearchWarehousesDestination.map((item, index) => (
                                            <li key={index} onClick={() => selectWarehouseDestination(item)}>
                                                <a>{item.codigo_armazem} - {item.descricao}</a>
                                            </li>
                                        ))}
                                    </ul>
                                </div>
                            </div>
                            <div className="divGroup">
                                <div className="formDiv">
                                    <label>Endereço Destino</label>&nbsp;<label className="required">*</label><br />
                                    <input type="text" placeholder="Endereço Destino" value={label_address_destination}
                                        onChange={(e) => {
                                            setLabelAddressDestination(e.target.value);
                                            searchAddressDestination(e.target.value);
                                        }} maxLength="60" />
                                    <ul className="dropdown-menu" id="destinationAddressDatalist">
                                        {listSearchAddressDestination.map((item, index) => (
                                            <li key={index} onClick={() => selectAddressDestination(item)}>
                                                <a>{item.endereco}</a>
                                            </li>
                                        ))}
                                    </ul>
                                </div>
                            </div>
                        </div>}
                        <div className="divGroup">
                            <div className="formDiv">
                                <button type="button" className="buttonSubmit inputSm marginRight" onClick={save}
                                    disabled={enableConfirm}>Confirmar
                                </button>
                                <button type="button" className="buttonCancel inputSm pullRight"
                                    onClick={openExitConference}>Fechar
                                </button>
                            </div>
                        </div>
                    </div>
                </Modal>
            </div>}
        </div>
    )
}